import 'ui-core/components/truncater/js/truncater';

UX.truncater.vPort = 'screen-md';

if ($('article.magazine').length) {
    $('.title-2l, .abstract-2l').truncate({lines: 2});
}

if ($('.volume__list').length) {
    $('.volume-title a').truncate({
        lines: 5,
    });
}
